export const ToQueryParams = (obj: Object): string =>
  Object.entries(obj)
    .filter(([_key, value]) => value !== null && value !== '' && value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
